import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import store from 'app-components/utils/redux-store';

/**
 * Converts a payee name to a domain format for logo lookup
 * Examples:
 * - "Netflix" -> "netflix.com"
 * - "Amazon Prime" -> "amazon.com" (uses first word)
 * - "Amazon Prime Video" -> "amazon.com" (uses first word)
 * - "amazon.com" -> "amazon.com" (already a domain)
 * - "Spotify Premium" -> "spotify.com" (uses first word)
 */

const getFF = () => store && featureFlagsSelectors.getFeatureFlags(store.getState()).get('logosSeriesRelease');

export function payeeNameToDomain(payeeName: string): string {
  if (!payeeName) return '';
  if (!getFF()) return '';

  // If it already looks like a domain, extract and return it
  if (/[a-z0-9-]+\.(com|net|org|io|co|edu|gov)\b/i.test(payeeName)) {
    // Extract just the domain part if it's a full URL
    const domainMatch = payeeName.match(/(?:www\.)?([a-zA-Z0-9-]+\.(?:com|net|org|io|co|edu|gov))/);
    if (domainMatch) {
      return domainMatch[1].toLowerCase();
    }
    return payeeName.toLowerCase();
  }

  // For multiple words, use the first word as the company name
  // This handles cases like "Amazon Prime Video" -> "amazon.com"
  const words = payeeName.trim().split(/\s+/);
  const firstWord = words[0];

  // Remove any special characters and convert to lowercase
  const cleaned = firstWord.replace(/[^a-zA-Z0-9-]/g, '').toLowerCase();

  // Add .com extension
  return `${cleaned}.com`;
}
